import { useMemo } from 'react';
import { WEEK_LABEL } from '@/consts/bodyAndPaint';

interface CalendarDateListHookProps {
  month: Date;
}
export const useCalendarDateList = ({ month }: CalendarDateListHookProps) => {
  const weekLabel = Object.keys(WEEK_LABEL);
  const currentMonth = useMemo(() => month.getMonth(), [month]);
  const calendarStart = useMemo(() => {
    const first = 1;
    const firstDate = new Date(month);
    firstDate.setDate(first);
    const startDayOfWeek = new Date(firstDate).getDay();
    return new Date(
      firstDate.getFullYear(),
      firstDate.getMonth(),
      firstDate.getDate() - startDayOfWeek,
    );
  }, [month]);

  const dateItemList = useMemo(() => {
    const length = 42;
    return Array.from({ length }, (_, idx) => {
      const date = new Date(calendarStart);
      date.setDate(calendarStart.getDate() + idx);
      return date;
    })
      .reduce((week, date, idx) => {
        if (idx % weekLabel.length === 0) {
          week.push([]);
        }
        const offset = 1;
        week[week.length - offset].push(date);
        return week;
      }, [] as Date[][])
      .filter((week) => week.some((date) => date.getMonth() === currentMonth))
      .map((week) =>
        week.map((date) => {
          return new Date(date.setHours(0, 0, 0, 0));
        }),
      );
  }, [currentMonth, calendarStart, weekLabel]);
  return { dateItemList };
};
